import React from "react";

export default function Simplecast({ attributes, element, children }) {
  const { src: embedUrl, height } = element;

  return (
    <div {...attributes}>
      <div
        css={{
          display: "none",
          userSelect: "none",
        }}
      >
        {children}
      </div>
      <div contentEditable={false}>
        <div
          css={{
            border: "1px solid #ccc",
            borderRadius: 4,
            overflow: "hidden",
            marginTop: 10,
            display: "flex",
          }}
        >
          <iframe
            src={embedUrl}
            frameBorder="0"
            css={{
              width: "100%",
              height,
            }}
            style={{
              width: "100%",
              height,
            }}
          />
        </div>
      </div>
    </div>
  );
}
